module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [(_vm.sportOptions.length > 2) ? _c('div', {
    staticClass: "sport-filter"
  }, _vm._l((_vm.sportOptions), function(opt) {
    return _c('button', {
      key: opt,
      staticClass: "sport-pill",
      class: {
        active: _vm.selectedSport === opt
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.selectSport(opt)
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.sportLabel(opt)) + "\n        ")])
  })) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredPicks), function(p) {
    return (_vm.picks) ? _c('pick', {
      key: p.id,
      attrs: {
        "pick": p
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.picks && _vm.picks.length === 0) ? _c('p', [_vm._v("\n        There are no premium picks currently posted. To receive picks\n        immediately when they are posted, please set up pick notifications in\n        the\n        "), _c('router-link', {
    attrs: {
      "to": {
        path: '/myaccount'
      }
    }
  }, [_vm._v("\n          my account section.\n        ")])], 1) : _vm._e()], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "7997332272",
      "ad-style": "display:inline-block;width:250px;height:250px",
      "ad-format": "auto"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-74a7c77a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ViewPicks.vue
// module id = 514
// module chunks = 1